const styles = {
  wrapper: {
    '@media (min-width: 992px)': {
      padding: `0 25px`
    }
  },
  box: {
    '@media (min-width: 992px)': {
      padding: `20px`,
      border: `1px solid #ddd`,
      borderRadius: `3px`
    }
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/components/Statistics/style/graph.js